import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import Featured from './components/Featured';
import Trending from './components/Trending';
import Genres from './components/Genres';
import Gems from './components/Gems';
import Faq from './components/Faq';
import AboutStrip from './components/AboutStrip';
import useSeo from '@/hooks/useSeo';
import { site } from '@/mocks/manhwa';

export default function HomePage() {
  useSeo({
    title: '好看的韩漫推荐 好看的韩漫推荐 | 好看的韩漫推荐书单精选必看收藏版',
    description:
      '整理一份好看的韩漫推荐书单，从高分人气到冷门宝藏都有收录。按题材分类列出必看作品，方便你快速找到合口味的韩漫，追更不迷路。',
    keywords: '好看的韩漫推荐,好看的韩漫推荐书单,好看的韩漫推荐必看,好看的韩漫推荐精选,好看的韩漫推荐收藏,韩漫书单',
    path: '/',
    type: 'website',
    jsonLd: [
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: site.brand,
        url: `${window.location.origin}`,
        description: '好看的韩漫推荐书单，收录高分人气与冷门宝藏韩漫，按题材分类推荐。',
        potentialAction: {
          '@type': 'SearchAction',
          target: `${window.location.origin}/category/{search_term_string}`,
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: site.brand,
        url: `${window.location.origin}`,
        email: site.email,
        slogan: site.slogan,
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: '好看的韩漫推荐网站主要推荐什么类型的作品？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '本站收录的韩漫推荐涵盖都市日常、奇幻冒险、恋爱、热血战斗、悬疑惊悚、穿越重生和治愈暖萌等多种题材，既有人气高分大作，也有冷门宝藏，按题材分类整理，方便你快速找到合口味的作品。',
            },
          },
          {
            '@type': 'Question',
            name: '高分人气榜是怎么排出来的？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '高分人气榜综合了作品的读者评分与讨论热度，优先展示口碑与热度双在线的必看韩漫，榜单会随评分变化动态更新。',
            },
          },
          {
            '@type': 'Question',
            name: '冷门宝藏栏目里的作品质量可靠吗？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '冷门宝藏栏目的作品由编辑人工筛选，特点是口碑好但相对冷门，适合想挖宝换口味的老读者，每部都经过试读与评估。',
            },
          },
        ],
      },
    ],
  });

  return (
    <div className="bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <Featured />
        <Trending />
        <Genres />
        <Gems />
        <Faq />
        <AboutStrip />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}

function BackToTop() {
  return (
    <button
      type="button"
      aria-label="返回顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 transition-colors hover:bg-primary-600"
    >
      <i className="ri-arrow-up-line text-lg" />
    </button>
  );
}